import { createSlice } from '@reduxjs/toolkit'

export type Options = Array<{ value: string | boolean | number; label: string }>

export const maritalStatusOptions = [
  { value: 'unmarried', label: 'Unmarried' },
  { value: 'married', label: 'Married' },
]

export const propertyUsageOptions = [
  { value: 'principal-residence', label: 'Principal Residence' },
  { value: 'second-home', label: 'Second Home' },
  { value: 'investment', label: 'Investment' },
]

export const propertyTypeOptions = [
  { value: 'single-family-detached', label: 'Single Family Detached' },
  { value: 'condominium', label: 'Condominium' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: '2-4-unit', label: '2-4 Unit' },
]

export const corelogicPropertyTypeOptions = [
  { value: 'agricultural', label: 'Agricultural' },
  { value: 'amusement-recreation', label: 'Amusement-Recreation' },
  { value: 'apartment', label: 'Apartment' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'commercial-condominium', label: 'Commercial Condominium' },
  { value: 'condominium', label: 'Condominium' },
  { value: 'duplex', label: 'Duplex' },
  { value: 'exempt', label: 'Exempt' },
  { value: 'financial-institution', label: 'Financial Institution' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'hotel-motel', label: 'Hotel Motel' },
  { value: 'industrial', label: 'Industrial' },
  { value: 'industrial-heavy', label: 'Industrial Heavy' },
  { value: 'industrial-light', label: 'Industrial Light' },
  { value: 'miscellaneous', label: 'Miscellaneous' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'office-building', label: 'Office Building' },
  { value: 'planned-unit-development', label: 'Planned Unit Development' },
  { value: 'parking', label: 'Parking' },
  { value: 'retail', label: 'Retail' },
  { value: 'service', label: 'Service' },
  { value: 'single-family-residence', label: 'Single Family Residence' },
  { value: 'transport', label: 'Transport' },
  { value: 'utilities', label: 'Utilities' },
  { value: 'vacant', label: 'Vacant' },
  { value: 'warehouse', label: 'Warehouse' },
]

export const titleHeldOptions = [
  { value: 'individual', label: 'Individual' },
  { value: 'joint-tenants', label: 'Joint Tenants' },
  { value: 'community-property', label: 'Community Property' },
  {
    value: 'community-property-with-right-of-survivorship',
    label: 'Community Property With Right Of Survivorship',
  },
  { value: 'tenants-in-common', label: 'Tenants in Common' },
  { value: 'trust', label: 'Trust' },
  { value: 'corporation-llc', label: 'Corporation/LLC' },
  { value: 'other', label: 'Other' },
]

export const useOfProceedsOptions = [
  { value: 'pay-off-debt', label: 'Pay Off Debt' },
  { value: 'covid-relief', label: 'COVID Relief' },
  { value: 'settle-a-divorce', label: 'Settle a Divorce' },
  { value: 'real-estate-investing', label: 'Real Estate Investing' },
  { value: 'renovate-home', label: 'Renovate Home' },
  { value: 'maintain-home', label: 'Maintain Home' },
  { value: 'cash-cushion', label: 'Cash Cushion' },
  { value: 'diversify-portfolio', label: 'Diversify Portfolio' },
  { value: 'fund-education', label: 'Fund Education' },
  { value: 'finance-business', label: 'Finance Business' },
]

export const mortgageProductTypeOptions = [
  { value: 'fixed-rate-mortgage', label: 'Fixed' },
  { value: 'adjustable-rate-mortgage', label: 'ARM' },
  { value: 'heloc-second-mortgage', label: 'HELOC/2ND' },
  { value: 'reverse-mortgage', label: 'Reverse' },
  { value: 'other', label: 'Other' },
]

export const accountTypeOptions = [
  { value: 'Mortgage', label: 'Mortgage' },
  { value: 'Heloc', label: 'HELOC' },
  { value: 'Solar', label: 'SOLAR' },
  { value: 'Revolving', label: 'Revolving' },
  { value: 'Installment', label: 'Installment' },
]

export const creditLoanTypeOptions = [
  { value: 'Airplane', label: 'Airplane' },
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'ApplianceOrFurniture', label: 'Appliance Or Furniture' },
  { value: 'AttorneyFees', label: 'Attorney Fees' },
  { value: 'AutoLease', label: 'Auto Lease' },
  { value: 'AutoLoanEquityTransfer', label: 'Auto Loan Equity Transfer' },
  { value: 'Automobile', label: 'Automobile' },
  { value: 'AutoRefinance', label: 'Auto Refinance' },
  {
    value: 'BiMonthlyMortgageTermsInYears',
    label: 'Bi Monthly Mortgage Terms In Years',
  },
  { value: 'Boat', label: 'Boat' },
  { value: 'Business', label: 'Business' },
  { value: 'BusinessCreditCard', label: 'Business Credit Card' },
  { value: 'Camper', label: 'Camper' },
  { value: 'ChargeAccount', label: 'Charge Account' },
  {
    value: 'CheckCreditOrLineOfCredit',
    label: 'Check Credit Or Line Of Credit',
  },
  { value: 'ChildSupport', label: 'Child Support' },
  { value: 'Collection', label: 'Collection' },
  { value: 'CollectionAttorney', label: 'Collection Attorney' },
  { value: 'Comaker', label: 'Comaker' },
  { value: 'CombinedCreditPlan', label: 'Combined Credit Plan' },
  {
    value: 'CommercialCreditObligation',
    label: 'Commercial Credit Obligation',
  },
  { value: 'CommercialLineOfCredit', label: 'Commercial Line Of Credit' },
  { value: 'CommercialMortgage', label: 'Commercial Mortgage' },
  { value: 'ConditionalSalesContract', label: 'Conditional Sales Contract' },
  {
    value: 'ConditionalSalesContractRefinance',
    label: 'Conditional Sales Contract Refinance',
  },
  { value: 'Consolidation', label: 'Consolidation' },
  { value: 'ConstructionLoan', label: 'Construction Loan' },
  {
    value: 'ConventionalRealEstateMortgage',
    label: 'Conventional Real Estate Mortgage',
  },
  { value: 'CreditCard', label: 'Credit Card' },
  { value: 'CreditLineSecured', label: 'Credit Line Secured' },
  { value: 'DebitCard', label: 'Debit Card' },
  { value: 'DebtCounselingService', label: 'Debt Counseling Service' },
  { value: 'DeferredStudentLoan', label: 'Deferred Student Loan' },
  { value: 'DepositRelated', label: 'Deposit Related' },
  { value: 'Educational', label: 'Educational' },
  { value: 'Employment', label: 'Employment' },
  { value: 'FactoringCompanyAccount', label: 'Factoring Company Account' },
  { value: 'FamilySupport', label: 'Family Support' },
  {
    value: 'FarmersHomeAdministrationFHMA',
    label: 'Farmers Home Administration Fhma',
  },
  { value: 'FederalConsolidatedLoan', label: 'Federal Consolidated Loan' },
  { value: 'FHAComakerNotBorrower', label: 'Fha Comaker Not Borrower' },
  { value: 'FHAHomeImprovement', label: 'Fha Home Improvement' },
  { value: 'FHARealEstateMortgage', label: 'Fha Real Estate Mortgage' },
  { value: 'FinanceStatement', label: 'Finance Statement' },
  { value: 'GovernmentBenefit', label: 'Government Benefit' },
  { value: 'GovernmentEmployeeAdvance', label: 'Government Employee Advance' },
  { value: 'GovernmentFeeForService', label: 'Government Fee For Service' },
  { value: 'GovernmentFine', label: 'Government Fine' },
  { value: 'GovernmentGrant', label: 'Government Grant' },
  {
    value: 'GovernmentMiscellaneousDebt',
    label: 'Government Miscellaneous Debt',
  },
  { value: 'GovernmentOverpayment', label: 'Government Overpayment' },
  {
    value: 'GovernmentSecuredDirectLoan',
    label: 'Government Secured Direct Loan',
  },
  {
    value: 'GovernmentSecuredGuaranteeLoan',
    label: 'Government Secured Guarantee Loan',
  },
  {
    value: 'GovernmentUnsecuredDirectLoan',
    label: 'Government Unsecured Direct Loan',
  },
  {
    value: 'GovernmentUnsecuredGuaranteeLoan',
    label: 'Government Unsecured Guarantee Loan',
  },
  { value: 'HomeEquity', label: 'Home Equity' },
  { value: 'HomeEquityLineOfCredit', label: 'Home Equity Line Of Credit' },
  { value: 'HomeImprovement', label: 'Home Improvement' },
  { value: 'HouseholdGoods', label: 'Household Goods' },
  {
    value: 'HouseholdGoodsAndOtherCollateralAuto',
    label: 'Household Goods And Other Collateral Auto',
  },
  { value: 'HouseholdGoodsSecured', label: 'Household Goods Secured' },
  { value: 'InstallmentLoan', label: 'Installment Loan' },
  { value: 'InstallmentSalesContract', label: 'Installment Sales Contract' },
  { value: 'InsuranceClaims', label: 'Insurance Claims' },
  { value: 'Lease', label: 'Lease' },
  { value: 'LenderPlacedInsurance', label: 'Lender Placed Insurance' },
  { value: 'ManualMortgage', label: 'Manual Mortgage' },
  { value: 'ManufacturedHome', label: 'Manufactured Home' },
  { value: 'MedicalDebt', label: 'Medical Debt' },
  { value: 'MobileHome', label: 'Mobile Home' },
  { value: 'MobilePhone', label: 'Mobile Phone' },
  { value: 'Mortgage', label: 'Mortgage' },
  { value: 'NoteLoan', label: 'Note Loan' },
  { value: 'NoteLoanWithComaker', label: 'Note Loan With Comaker' },
  { value: 'Other', label: 'Other' },
  { value: 'PartiallySecured', label: 'Partially Secured' },
  { value: 'PersonalLoan', label: 'Personal Loan' },
  { value: 'RealEstateJuniorLiens', label: 'Real Estate Junior Liens' },
  {
    value: 'RealEstateLoanEquityTransfer',
    label: 'Real Estate Loan Equity Transfer',
  },
  {
    value: 'RealEstateMortgageWithoutOtherCollateral',
    label: 'Real Estate Mortgage Without Other Collateral',
  },
  {
    value: 'RealEstateSpecificTypeUnknown',
    label: 'Real Estate Specific Type Unknown',
  },
  { value: 'Recreational', label: 'Recreational' },
  { value: 'RecreationalVehicle', label: 'Recreational Vehicle' },
  { value: 'Refinance', label: 'Refinance' },
  { value: 'RefundAnticipationLoan', label: 'Refund Anticipation Loan' },
  { value: 'RentalAgreement', label: 'Rental Agreement' },
  { value: 'ResidentialLoan', label: 'Residential Loan' },
  { value: 'ReturnedCheck', label: 'Returned Check' },
  { value: 'RevolvingBusinessLines', label: 'Revolving Business Lines' },
  { value: 'SecondMortgage', label: 'Second Mortgage' },
  { value: 'Secured', label: 'Secured' },
  { value: 'SecuredByCosigner', label: 'Secured By Cosigner' },
  { value: 'SecuredCreditCard', label: 'Secured Credit Card' },
  { value: 'SecuredHomeImprovement', label: 'Secured Home Improvement' },
  {
    value: 'SemiMonthlyMortgagePayment',
    label: 'Semi Monthly Mortgage Payment',
  },
  { value: 'SinglePaymentLoan', label: 'Single Payment Loan' },
  { value: 'SpouseSupport', label: 'Spouse Support' },
  {
    value: 'SummaryOfAccountsWithSameStatus',
    label: 'Summary Of Accounts With Same Status',
  },
  { value: 'TimeSharedLoan', label: 'Time Shared Loan' },
  { value: 'Title1Loan', label: 'Title1 Loan' },
  { value: 'UnknownLoanType', label: 'Unknown Loan Type' },
  { value: 'Unsecured', label: 'Unsecured' },
  { value: 'UtilityCompany', label: 'Utility Company' },
  {
    value: 'VeteransAdministrationLoan',
    label: 'Veterans Administration Loan',
  },
  {
    value: 'VeteransAdministrationRealEstateMortgage',
    label: 'Veterans Administration Real Estate Mortgage',
  },
]

export const appraisalOrderPropertyTypeOptions = [
  { value: 'single-family', label: 'Single Family' },
  { value: 'town-home', label: 'Town Home' },
  { value: 'condo', label: 'Condo' },
  { value: 'duplex', label: 'Duplex' },
  { value: 'multi-family', label: 'Multi-Family' },
  { value: 'other', label: 'Other' },
  { value: 'pud', label: 'PUD' },
]

export const AppraisalReportTypes = {
  HYBRID: 'hybrid',
  CONDO_1073: 'condo-1073',
  MULTI_1025: 'multi-1025',
  REVISION_1004D: '1004D',
  FNMA_1004_SINGLE_FAMILY: 'fnma-1004-single-family',
  IVALUE_NET_55: 'ivaluenet-55',
  BROKER_PRICE_OPINION_EXT: 'A112',
  BROKER_PRICE_OPINION_INT: 'A113',
}

export const appraisalOrderReportTypeOptions = [
  { value: AppraisalReportTypes.HYBRID, label: 'Hybrid Cascade' },
  { value: AppraisalReportTypes.CONDO_1073, label: 'Condo (1073)' },
  { value: AppraisalReportTypes.MULTI_1025, label: 'Multi (1025)' },
  { value: AppraisalReportTypes.REVISION_1004D, label: '1004D (revision)' },
  { value: AppraisalReportTypes.FNMA_1004_SINGLE_FAMILY, label: 'FNMA 1004 Single Family' },
  { value: AppraisalReportTypes.IVALUE_NET_55, label: 'iValueNet 55' },
  { value: AppraisalReportTypes.BROKER_PRICE_OPINION_EXT, label: 'BPO Ext' },
  { value: AppraisalReportTypes.BROKER_PRICE_OPINION_INT, label: 'BPO Int' },
]

export const exceptionsOptions = [
  { value: 'home-value', label: 'HV' },
  { value: 'investment-size', label: 'Inv Size' },
  { value: 'property-condition', label: 'PC' },
  { value: 'debt-service-coverage-ratio', label: 'DSCR' },
  { value: 'third-lien', label: '3rd Lien' },
  { value: 'exotic-mortgage', label: 'I/O Neg AM' },
  { value: 'bankruptcy', label: 'BK' },
  { value: 'mortgage-late', label: 'MTG Late' },
  { value: 'foreclosure', label: 'FC' },
  { value: 'short-sale', label: 'SS' },
  { value: 'deed-in-lieu', label: 'DIL' },
]

export const excludeExceptions = ['total-home-finance', 'forbearance']

export const solarExceptionPathOptions = [
  {
    value: 'financed-not-paying-off',
    label: 'Path 1 - Solar financed & Unlock NOT paying off',
  },
  {
    value: 'financed-paying-off-as-condition',
    label: 'Path 2 - Solar financed & Unlock IS paying off',
  },
  {
    value: 'owned-free-and-clear',
    label: 'Path 3 - Subj. has solar & owned free and clear',
  },
]

export const creditLiabilityTypeOptions = [
  { value: 'CreditLine', label: 'CreditLine' },
  { value: 'Installment', label: 'Installment' },
  { value: 'Open', label: 'Open' },
  { value: 'Revolving', label: 'Revolving' },
  { value: 'Unknown', label: 'Unknown' },
]

export const payoffTypeOptions = [
  { value: 'auto', label: 'Auto' },
  { value: 'child-support', label: 'Child Support' },
  { value: 'credit-card', label: 'Credit Card' },
  { value: 'dpa-lien', label: 'Dpa Lien' },
  { value: 'dti-other', label: 'DTI - Other' },
  { value: 'heloc', label: 'HELOC' },
  { value: 'hoa', label: 'HOA' },
  { value: 'hoa-lien', label: 'HOA Lien' },
  { value: 'hud', label: 'HUD' },
  { value: 'installment-loan', label: 'Installment Loan' },
  { value: 'insurance-premium', label: 'Insurance Premium' },
  { value: 'irs-lien', label: 'IRS Lien' },
  { value: 'judgments', label: 'Judgments' },
  { value: 'mtg-dq-30', label: 'MTG DQ 30' },
  { value: 'mtg-dq-60', label: 'MTG DQ 60' },
  { value: 'mvr', label: 'MVR' },
  { value: 'property-financing-lien', label: 'Property Financing Lien' },
  { value: 'property-taxes', label: 'Property Taxes' },
  { value: 'property-tax-lien', label: 'Property Tax Lien' },
  { value: 'solar-lien', label: 'Solar Lien' },
  { value: 'state-tax-lien', label: 'State Tax Lien' },
  { value: 'trash-waste-lien', label: 'Trash/Waste Lien' },
  { value: 'water-sewer-lien', label: 'Water/Sewer Lien' },
]

export const insuranceTypeOptions = [
  { value: 'ho_3', label: 'HO-3' },
  { value: 'ho_6', label: 'HO-6' },
  { value: 'master_hoa_policy', label: 'Master HOA Policy' },
  { value: 'flood', label: 'Flood' },
]

export const amortizationTypeOptions = [
  { value: 'p-and-i', label: 'P&I' },
  { value: 'neg-am', label: 'NegAm' },
  { value: 'io', label: 'IO' },
  { value: 'deferred', label: 'Deferred' },
  { value: 'p-and-i-deferred', label: 'P&I (w/ Deferred)' },
]

export const escrowStatusTypeOptions = [
  { value: 'taxes-and-insurance', label: 'T&I' },
  { value: 'taxes-only', label: 'Taxes' },
  { value: 'insurance-only', label: 'Ins.' },
  { value: 'not-escrowed', label: 'None' },
]

interface ApplicationState {
  taxesOptions: Options
  pRReviewStatusOptions: Options
  appraisalTypeOptions: Options
  propertyConditionOptions: Options
  compSaleDateOptions: Options
  compDistanceFromSubjPropOptions: Options
  netGrossAdjOptions: Options
  escalateToUamOptions: Options
  mortgageDebtOptions: Options
  uamExceptionReviewChoices: Options
  expensePaidWhenOptions: Options
  appraisalReviewStatusOptions: Options
  propertyNeighborhoodLocationTypeOptions: Options
  propertyNeighborhoodBuiltUpRangeTypeOptions: Options
  propertyNeighborhoodGrowthPaceTypeOptions: Options
  conditionOfAppraisalTypeOptions: Options
  siteZoningComplianceTypeOptions: Options
  escrowStatusTypeOptions: Options
}

export const conditionOfAppraisalTypeOptions = [
  { value: 'as-is', label: 'As Is' },
  { value: 'other', label: 'Other' },
  { value: 'subject-to-completion', label: 'SubjectToCompletion' },
  { value: 'subject-to-inspections', label: 'SubjectToInspections' },
  { value: 'subject-to-repairs', label: 'SubjectToRepairs' },
]

export const appraisalReviewStatusOptions = [
  { value: 'approved', label: 'Approved' },
  { value: 'in-process', label: 'In Process' },
  { value: 'issue-found', label: 'Issue Found' },
  { value: 'recon-requested', label: 'Recon Requested' },
  { value: 'revision-requested', label: 'Revision Requested' },
]

export const taxesOptions = [
  { value: 'paid', label: 'Paid' },
  { value: 'due_at_closing', label: 'Due at Closing' },
  { value: 'escrowed', label: 'Escrowed' },
  { value: 'not_due_60_days', label: 'Not due for 60+ days' },
]

export const appraisalTypeOptions = [
  { value: 'hybrid', label: 'Hybrid Cascade' },
  { value: 'pcr', label: 'Property Condition Report' },
  { value: 'bpo', label: 'Brokers Price Opinion' },
  { value: 'ivaluenet-55', label: 'iValueNet 55 (Comp Photos)' },
  { value: 'fnma-1004-single-family', label: 'FNMA 1004 Single Family' },
  { value: 'condo-1073', label: 'Condo (1073)' },
  { value: 'multi-1025', label: 'Multi (1025)' },
  { value: '1004D', label: '1004D (revision)' },
]

export const propertyNeighborhoodLocationTypeOptions = [
  { value: 'urban', label: 'Urban' },
  { value: 'suburban', label: 'Suburban' },
  { value: 'rural', label: 'Rural' },
]

export const propertyNeighborhoodBuiltUpRangeTypeOptions = [
  { value: 'under-twenty-five-percent', label: 'Under 25%' },
  { value: 'twenty-five-to-seventy-five-percent', label: '25-75%' },
  { value: 'over-seventy-five-percent', label: 'Over 75%' },
]

export const propertyNeighborhoodGrowthPaceTypeOptions = [
  { value: 'slow', label: 'Slow' },
  { value: 'stable', label: 'Stable' },
  { value: 'rapid', label: 'Rapid' },
]

export const compSaleDateOptions = [
  { value: 6, label: '1-6 months' },
  { value: 12, label: '7-12 months' },
  { value: 24, label: 'Over 12 months' },
]

export const compDistanceFromSubjPropOptions = [
  { value: false, label: 'Less than 1 mile' },
  { value: true, label: 'More than 1 mile' },
]

export const siteZoningComplianceTypeOptions = [
  { value: 'illegal', label: 'Illegal' },
  { value: 'legal', label: 'Legal' },
  { value: 'non-conforming', label: 'Non Conforming' },
  { value: 'no-zoning', label: 'No Zoning' },
]

const initialState: ApplicationState = {
  taxesOptions: taxesOptions,
  pRReviewStatusOptions: [
    { value: 'fast_track', label: 'Fast Track' },
    { value: 'parking_lot', label: 'Parking Lot' },
  ],
  appraisalTypeOptions: appraisalTypeOptions,
  propertyConditionOptions: [
    { value: 'c1', label: 'c1' },
    { value: 'c2', label: 'c2' },
    { value: 'c3', label: 'c3' },
    { value: 'c4', label: 'c4' },
    { value: 'c5', label: 'c5' },
    { value: 'c6', label: 'c6' },
  ],
  compSaleDateOptions: compSaleDateOptions,
  compDistanceFromSubjPropOptions: compDistanceFromSubjPropOptions,
  netGrossAdjOptions: [
    { value: 5, label: '0-5%' },
    { value: 10, label: '6-10%' },
    { value: 15, label: '10+%' },
  ],
  escalateToUamOptions: [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ],
  mortgageDebtOptions: [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ],
  uamExceptionReviewChoices: [
    { value: 'uam_review_required', label: 'UAM Review Required' },
    { value: 'no_review_required', label: 'No Review Required' },
    { value: 'uam_approved', label: 'UAM Approved' },
    { value: 'uam_declined', label: 'UAM Declined' },
  ],
  expensePaidWhenOptions: [
    { value: 'at-closing', label: 'At Closing' },
    { value: 'before-closing', label: 'Before Closing' },
  ],
  appraisalReviewStatusOptions: appraisalReviewStatusOptions,
  propertyNeighborhoodLocationTypeOptions: propertyNeighborhoodLocationTypeOptions,
  propertyNeighborhoodBuiltUpRangeTypeOptions: propertyNeighborhoodBuiltUpRangeTypeOptions,
  propertyNeighborhoodGrowthPaceTypeOptions: propertyNeighborhoodGrowthPaceTypeOptions,
  conditionOfAppraisalTypeOptions: conditionOfAppraisalTypeOptions,
  siteZoningComplianceTypeOptions: [
    { value: 'illegal', label: 'Illegal' },
    { value: 'legal', label: 'Legal' },
    { value: 'non-conforming', label: 'Non Conforming' },
    { value: 'no-zoning', label: 'No Zoning' },
  ],
  escrowStatusTypeOptions: [
    { value: 'taxes-and-insurance', label: 'T&I' },
    { value: 'taxes-only', label: 'Taxes' },
    { value: 'insurance-only', label: 'Ins.' },
    { value: 'not-escrowed', label: 'None' },
  ],
}

export const applicationSlice = createSlice({
  name: 'application',

  initialState,

  reducers: {},
})

export const typeOptions = [
  { label: 'Application', value: 'application' },
  { label: 'Homeowner Docs', value: 'homeowner-docs' },
  { label: 'Credit', value: 'credit' },
  { label: 'AVM', value: 'avm' },
  { label: 'Supplemental', value: 'supplemental' },
  { label: 'Legal', value: 'legal' },
  { label: 'Appraisal', value: 'appraisal' },
  { label: 'Title', value: 'title' },
  { label: 'Inspection', value: 'inspection' },
  { label: 'Closing', value: 'closing' },
  { label: 'HOA', value: 'hoa' },
  { label: 'Message Reply', value: 'message-reply' },
  { label: 'Payoff', value: 'payoff' },
  { label: 'Forbearance', value: 'forbearance' },
  { label: 'Email', value: 'email' },
  { label: 'Credit Reports', value: 'credit-reports' },
  { label: 'Lien Alerts', value: 'lien-alerts' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'Final Disposition', value: 'final-disposition' },
  { label: 'Servicing', value: 'servicing' },
]

/**
 * @deprecated
 * @use /v2/document-template/
 * */
export const documentOptionsMappingByType = {
  application: [
    {
      value: 'initial-application-for-unlock-agreement',
      label: 'Initial Application for Unlock Agreement',
    },
  ],
  'homeowner-docs': [
    { value: 'applicant-id', label: 'Applicant ID' },
    { value: 'co-applicant-identification', label: 'Co-Applicant Identification' },
    { value: 'mortgage-statement-first', label: 'Mortgage Statement - First' },
    { value: 'mortgage-statement-second', label: 'Mortgage Statement - Second' },
    { value: 'homeowners-insurance', label: 'Homeowners Insurance' },
    { value: 'rental-income-proof', label: 'Rental Income Proof' },
    { value: 'trust-documents', label: 'Trust Documents' },
  ],
  credit: [
    { value: 'credit-report', label: 'Credit Report' },
    {
      value: 'verification-of-mortgage-credit-supplement',
      label: 'Verification of Mortgage Credit Supplement',
    },
  ],
  avm: [
    { value: 'corelogic-consumer-avm', label: 'CoreLogic Consumer AVM' },
    { value: 'corelogic-risk-avm', label: 'CoreLogic Risk AVM' },
    { value: 'bkfs-ca-value-avm', label: 'BKFS CA Value AVM' },
    { value: 'housecanary-avm', label: 'HouseCanary AVM' },
    { value: 'housecanary-hpa-forecast', label: 'HouseCanary HPA Forecast' },
    { value: 'cape-analytics-property-condition', label: 'Cape Analytics Property Condition' },
  ],
  supplemental: [
    { value: 'income-documentation', label: 'Income Documentation' },
    { value: 'letter-of-explanation', label: 'Letter of Explanation' },
    { value: 'other', label: 'Other' },
  ],
  legal: [
    { value: 'investment-estimate', label: 'Investment Estimate' },
    { value: 'unlock-program-guide', label: 'Unlock Program Guide' },
    { value: 'investment-estimate-executed', label: 'Investment Estimate - Executed' },
    { value: 'deferred-maintenance-items', label: 'Deferred Maintenance Items' },
    { value: 'closing-statement', label: 'Closing Statement' },
    {
      value: 'sample-forward-sale-and-exchange-agreement',
      label: 'Sample Forward Sale and Exchange Agreement',
    },
    { value: 'sample-performance-deed-of-trust', label: 'Sample Performance Deed of Trust' },
    {
      value: 'final-application-for-unlock-agreement',
      label: 'Final Application for Unlock Agreement',
    },
    { value: 'closing-statement-executed', label: 'Closing Statement - Executed' },
    {
      value: 'final-application-for-unlock-agreement-executed',
      label: 'Final Application for Unlock Agreement - Executed',
    },
    { value: 'forward-sale-and-exchange-agreement', label: 'Forward Sale and Exchange Agreement' },
    { value: 'performance-deed-of-trust', label: 'Performance Deed of Trust' },
    {
      value: 'forward-sale-and-exchange-agreement-executed',
      label: 'Forward Sale and Exchange Agreement - Executed',
    },
    { value: 'performance-deed-of-trust-executed', label: 'Performance Deed of Trust - Executed' },
    { value: 'performance-deed-of-trust-recorded', label: 'Performance Deed of Trust - Recorded' },
  ],
  appraisal: [
    { value: 'appraisal', label: 'Appraisal' },
    { value: 'appraisal-xml', label: 'Appraisal XML' },
  ],
  title: [
    { value: 'preliminary-title-report', label: 'Preliminary Title Report' },
    { value: 'final-title-report', label: 'Final Title Report' },
  ],
  inspection: [
    { value: 'home-inspection-report', label: 'Home Inspection Report' },
    { value: 'termite-inspection-report', label: 'Termite Inspection Report' },
  ],
  closing: [
    { value: 'title-final-settlement-statement', label: 'Title Final Settlement Statement' },
    { value: 'closing-instructions', label: 'Closing Instructions' },
    { value: 'closing-package', label: 'Closing Package' },
  ],
  payoff: [{ value: 'payoff', label: 'Payoff' }],
  forbearance: [{ value: 'forbearance', label: 'Forbearance' }],
}

export default applicationSlice.reducer
